// extracted by mini-css-extract-plugin
export default {"main":"About_main__lKexV"};